export enum PAYMENT_TYPE {
  CLEARING = 'CLEARING',
  GROSS = 'GROSS',
  SWIFT = 'SWIFT',
  INTRABANK_TRANSFER_OWN = 'INTRABANK_TRANSFER_OWN',
  INTRABANK_TRANSFER_FOREIGN = 'INTRABANK_TRANSFER_FOREIGN',
  CONVERSION = 'CONVERSION',
  INTRABANK_TRANSFER_RKO_2_CARD_OWN = 'INTRABANK_TRANSFER_RKO_2_CARD_OWN',
  RKO_2_BUSINESS_CARD_FOREIGN = 'RKO_2_BUSINESS_CARD_FOREIGN',
  RKO_2_BUSINESS_CARD_OWN = 'RKO_2_BUSINESS_CARD_OWN',
  RKO_2_INDIVIDUAL_CARD_FOREIGN = 'RKO_2_INDIVIDUAL_CARD_FOREIGN',
  RKO_2_INDIVIDUAL_CARD_OWN = 'RKO_2_INDIVIDUAL_CARD_OWN',
  BUSINESS_CARD_2_RKO_OWN = 'BUSINESS_CARD_2_RKO_OWN',
  BUSINESS_CARD_2_RKO_FOREIGN = 'BUSINESS_CARD_2_RKO_FOREIGN',
  BUDGET_PAYMENT = 'BUDGET_PAYMENT',
  REFUND = 'REFUND',
  QR = 'QR',
  TRANSFER_BY_INVOICE = 'TRANSFER_BY_INVOICE',
}

export enum PaymentFormParameters {
  CLEARING_GROSS = 'clearing-gross',
  INTRA_BANK_TRANSFER = 'intra-bank-transfer',
  SWIFT = 'swift',
  CONVERSION = 'conversion',
  CARD_TRANSFER = 'card-transfer',
  CARD_TRANSFER_O24 = 'card-transfer-o24',
  CARD_TRANSFER_RKO = 'card-transfer-rko',
  BUDGET = 'budget',
  INVOICE = 'invoice',
  TRANSFER_BY_INVOICE = 'transfer-by-invoice',
}

export enum PaymentFormTarget {
  EDIT_PAYMENT = 'edit-payment',
  EDIT_TEMPLATE = 'edit-template',
}
